<template>
  <div class="dashboard-background min-vh-100">
    <dashboard-header />

    <!-- Topbar -->
    <dashboard-topbar title="Shared" />
    <!-- End Topbar -->

    <div class="dashboard-container py-20">
      <dashboard-breadcrumb
        class="-mt-2 mb-5"
        :breadcrumbs="breadcrumbs"
      />

      <div class="dashboard-projects-grid">
        <b-row>
          <b-col
            v-for="project in projects"
            :key="project.id"
            cols="12"
            md="6"
            lg="4"
            xl="3"
            class="mb-4"
          >
            <shared-projects :project="project" />
          </b-col>
        </b-row>
      </div>

      <div
        v-if="loadingMoreProjects"
        class="text-center py-5"
      >
        <b-spinner variant="primary" />
      </div>
    </div>
  </div>
</template>

<script>
import DashboardHeader from '../../layouts/dashboard/DashboardHeader'
import DashboardTopbar from '../../layouts/dashboard/DashboardTopbar'
import SharedProjects from '../../layouts/dashboard/compontens/shared/SharedProjects'
import DashboardBreadcrumb from '../../layouts/dashboard/compontens/topbar/DashboardBreadcrumb'

export default {
  name: 'Archive',
  components: {
    DashboardBreadcrumb,
    SharedProjects,
    DashboardTopbar,
    DashboardHeader
  },
  data () {
    return {
      projects: [],
      loadingMoreProjects: true,
      breadcrumbs: [{id: 0, name: 'All Sites'}, {name: 'Shared'}]
    }
  },

  created () {
    axios.get('api/projects/shared')
      .then(({data}) => {
        this.projects = data.data.data
      })
      .finally(() => {
        this.loadingMoreProjects = false
      })
  }
}
</script>